{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {},
      "geometry": {
        "coordinates": [
          [
            [
              -92.45261462046399,
              0.21604359398997985
            ],
            [
              -90.9814481178045,
              -1.9093172214256384
            ],
            [
              -88.85095209563595,
              -1.431588072198366
            ],
            [
              -88.33319786009811,
              -0.048503956190984354
            ],
            [
              -90.5900493745428,
              1.2805979497391462
            ],
            [
              -92.45261462046399,
              0.21604359398997985
            ]
          ]
        ],
        "type": "Polygon"
      }
    }
  ]
}